import { action, makeAutoObservable } from "mobx";
import INTOUCH_API from "../services/Api";
import Game from "../store/Game";

class General {
  reviews = [];
  isGameSectionsAvailable = false;
  gameOptions = [];
  formatGame = "";

  demoGame = {
    id: 0,
    demo: true,
    name: "bb2491ef-15fc-4b8b-895d-d0efb80530e0",
    invitedUserId: 1, // 1 for don't show link connect
    status: null,
    userId: 0,
    linkId: 0,
    createdAt: "2023-11-15T07:52:38.647Z",
    link: {
      id: 0,
      link: "19ef20e2-7782-4139-a719-29364f1ea257",
    },
    answers: [],
    partner: {
      id: 0,
      email: "",
      firstName: "",
      gender: "female",
      birthday: "1999-04-15T00:00:00.000Z",
    },
    isFinishedMarathon: false,
    isFinishedCompromise: false,
    isLoading: false,
  };

  constructor() {
    makeAutoObservable(this);
  }

  activateGameSections(value) {
    this.isGameSectionsAvailable = value;
  }
  async checkAnswers(gameId) {
    await INTOUCH_API.requestManager(
      "answersCheck",
      { gameId },
      action((response) => {
        this.activateGameSections(true);
        const action = this.gameOptions.find(
          (option) => option.gameId === gameId
        );
        this.setIsActionsAvailable({
          ...action,
          gameId,
          isMatchesAvailable: true,
        });
      }),
      action((error) => {
        this.activateGameSections(false);
        Game.setCountCompromiseMatches(null);
      })
    );
  }
  async checkChoosePartner(gameId) {
    await INTOUCH_API.requestManager(
      "check_choose_format",
      { gameId: gameId },
      action((response) => {
        const action = this.gameOptions.find(
          (option) => option.gameId === gameId
        );
        if (response?.data?.type === "marathon") {
          this.setIsActionsAvailable({
            ...action,
            gameId,
            continueMarathon: true,
          });
        }
      }),
      action((error) => {})
    );
  }
  setIsActionsAvailable(action) {
    const existingAction = this.gameOptions.find(
      (option) => option.gameId === action.gameId
    );
    if (existingAction) {
      this.gameOptions = this.gameOptions.map((gameOption) => {
        gameOption.gameId === action.gameId && (gameOption = action);
        return gameOption;
      });
      return;
    }
    this.gameOptions.push(action);
  }

  isMatchesAvailable(gameId) {
    return this.gameOptions.find((option) => option.gameId === gameId)
      ?.isMatchesAvailable;
  }
  isMarathonContinueAvailable(gameId) {
    return this.gameOptions.find((option) => option.gameId === gameId)
      ?.continueMarathon;
  }
  clearGameOptions() {
    this.gameOptions = [];
  }

  setInitialState() {
    this.reviews = [];
    this.isGameSectionsAvailable = false;
    this.gameOptions = [];
    this.formatGame = "";

    this.demoGame = {
      id: 0,
      demo: true,
      name: "bb2491ef-15fc-4b8b-895d-d0efb80530e0",
      invitedUserId: 1, // 1 for don't show link connect
      status: null,
      userId: 0,
      linkId: 0,
      createdAt: "2023-11-15T07:52:38.647Z",
      link: {
        id: 0,
        link: "19ef20e2-7782-4139-a719-29364f1ea257",
      },
      answers: [],
      partner: {
        id: 0,
        email: "",
        firstName: "",
        gender: "female",
        birthday: "1999-04-15T00:00:00.000Z",
      },
      isFinishedMarathon: false,
      isFinishedCompromise: false,
      isLoading: false,
    };
  }
}

export default new General();
